import DashboardView from './DashboardView'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { RootState } from '../../store'
import { useEffect } from 'react'
import { setLocationsAction } from '../Locations/locationsSlice'

export default () => {
    return <DashboardView />
}
